/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `Kód slevy byl úspěšně odstraněn`
};

const da_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatkoden er fjernet`
};

const de_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `Der Rabattcode wurde erfolgreich entfernt`
};

const en_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `The discount code has been successfully removed`
};

const es_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `El código promocional se ha eliminado correctamente`
};

const fr_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `Le code promo a été supprimé avec succès`
};

const hu_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `A promóciós kód sikeresen eltávolítva`
};

const it_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `Codice sconto rimosso con successo`
};

const nl_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `De kortingscode is succesvol verwijderd`
};

const pl_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `Kod rabatowy został usunięty`
};

const pt_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `O código promocional foi removido com sucesso`
};

const sv_discount_code_messages_removed = /** @type {(inputs: {}) => string} */ () => {
	return `Rabattkoden har tagits bort`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_code_messages_removed = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_code_messages_removed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_code_messages_removed", locale)
	if (locale === "cs") return cs_discount_code_messages_removed(inputs)
	if (locale === "da") return da_discount_code_messages_removed(inputs)
	if (locale === "de") return de_discount_code_messages_removed(inputs)
	if (locale === "en") return en_discount_code_messages_removed(inputs)
	if (locale === "es") return es_discount_code_messages_removed(inputs)
	if (locale === "fr") return fr_discount_code_messages_removed(inputs)
	if (locale === "hu") return hu_discount_code_messages_removed(inputs)
	if (locale === "it") return it_discount_code_messages_removed(inputs)
	if (locale === "nl") return nl_discount_code_messages_removed(inputs)
	if (locale === "pl") return pl_discount_code_messages_removed(inputs)
	if (locale === "pt") return pt_discount_code_messages_removed(inputs)
	return sv_discount_code_messages_removed(inputs)
};
export { discount_code_messages_removed as "discount_code_messages.removed" }